import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { STOGarantBanner } from '../components/STOGarantBanner';
import { CheckCircleIcon, CalendarIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export default function JoinPage() {
  return <div className="flex flex-col min-h-screen w-full" data-id="element-512">
      <Header data-id="element-513" />
      <main className="flex-grow" data-id="element-514">
        {/* Hero Section */}
        <section className="relative w-full h-[40vh] bg-cover bg-center" data-id="element-515">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1597520051247-7c333d694c7c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80')"
        }} data-id="element-516">
            <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-517"></div>
          </div>
          <div className="container mx-auto px-4 h-full flex items-center justify-center relative z-10" data-id="element-518">
            <div className="text-center text-white max-w-4xl" data-id="element-519">
              <h1 className="text-5xl md:text-6xl font-bold mb-4" data-id="element-520">
                Join a Trip
              </h1>
              <p className="text-xl" data-id="element-521">
                Ready to embark on an unforgettable hiking adventure? Sign up
                for one of our upcoming trips!
              </p>
            </div>
          </div>
        </section>
        {/* Book Now Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-522">
          <div className="container mx-auto px-4" data-id="element-523">
            <div className="text-center mb-12" data-id="element-524">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-525">
                Book Now
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-526">
                Fill out the form below to reserve your spot on one of our
                upcoming hiking adventures
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto" data-id="element-527">
              {/* Form Column */}
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-528">
                <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-529">
                  Registration Form
                </h3>
                <form className="space-y-6" data-id="element-530">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-531">
                    <div data-id="element-532">
                      <label htmlFor="firstName" className="block text-gray-700 font-medium mb-2" data-id="element-533">
                        First Name*
                      </label>
                      <input type="text" id="firstName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" required data-id="element-534" />
                    </div>
                    <div data-id="element-535">
                      <label htmlFor="lastName" className="block text-gray-700 font-medium mb-2" data-id="element-536">
                        Last Name*
                      </label>
                      <input type="text" id="lastName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" required data-id="element-537" />
                    </div>
                  </div>
                  <div data-id="element-538">
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-539">
                      Email Address*
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" required data-id="element-540" />
                  </div>
                  <div data-id="element-541">
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-2" data-id="element-542">
                      Phone Number*
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" required data-id="element-543" />
                  </div>
                  <div data-id="element-544">
                    <label htmlFor="trip" className="block text-gray-700 font-medium mb-2" data-id="element-545">
                      Select Trip*
                    </label>
                    <select id="trip" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" required data-id="element-546">
                      <option value="" data-id="element-547">Choose a trip...</option>
                      <option value="zakynthos-spring" data-id="element-548">
                        Zakynthos in Spring (New dates coming soon)
                      </option>
                      <option value="zakynthos-autumn" data-id="element-549">
                        Zakynthos in Autumn (03-10 Sep 2025)
                      </option>
                      <option value="cyprus-autumn" data-id="element-550">
                        Cyprus Autumn Try-out Trip (15-22 Oct 2025)
                      </option>
                      <option value="andalusia" data-id="element-551">
                        Andalusian Hiking Week (21-28 Sep 2025)
                      </option>
                    </select>
                  </div>
                  <div data-id="element-552">
                    <label htmlFor="participants" className="block text-gray-700 font-medium mb-2" data-id="element-553">
                      Number of Participants*
                    </label>
                    <select id="participants" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" required data-id="element-554">
                      <option value="1" data-id="element-555">1 person</option>
                      <option value="2" data-id="element-556">2 people</option>
                      <option value="3" data-id="element-557">3 people</option>
                      <option value="4" data-id="element-558">4 people</option>
                      <option value="5+" data-id="element-559">5+ people</option>
                    </select>
                  </div>
                  <div data-id="element-560">
                    <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-561">
                      Additional Information or Questions
                    </label>
                    <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-562"></textarea>
                  </div>
                  <div className="flex items-start" data-id="element-563">
                    <input type="checkbox" id="terms" className="mt-1 mr-2" required data-id="element-564" />
                    <label htmlFor="terms" className="text-gray-700" data-id="element-565">
                      I agree to the{' '}
                      <a href="/terms-conditions" className="text-teal-600 hover:underline" data-id="element-566">
                        terms and conditions
                      </a>{' '}
                      and acknowledge the{' '}
                      <a href="/privacy-policy" className="text-teal-600 hover:underline" data-id="element-567">
                        privacy policy
                      </a>
                      *
                    </label>
                  </div>
                  <button type="submit" className="w-full bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-6 rounded-md transition duration-300" data-id="element-568">
                    Submit Registration
                  </button>
                </form>
              </div>
              {/* Info Column */}
              <div className="space-y-8" data-id="element-569">
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-570">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-571">
                    What Happens Next?
                  </h3>
                  <ul className="space-y-4" data-id="element-572">
                    <li className="flex items-start" data-id="element-573">
                      <CheckCircleIcon size={24} className="text-teal-600 mr-3 mt-1 flex-shrink-0" data-id="element-574" />
                      <p className="text-gray-700" data-id="element-575">
                        After submitting your registration, you'll receive a
                        confirmation email within 24 hours.
                      </p>
                    </li>
                    <li className="flex items-start" data-id="element-576">
                      <CheckCircleIcon size={24} className="text-teal-600 mr-3 mt-1 flex-shrink-0" data-id="element-577" />
                      <p className="text-gray-700" data-id="element-578">
                        We'll send you detailed information about the trip,
                        including what to pack and how to prepare.
                      </p>
                    </li>
                    <li className="flex items-start" data-id="element-579">
                      <CheckCircleIcon size={24} className="text-teal-600 mr-3 mt-1 flex-shrink-0" data-id="element-580" />
                      <p className="text-gray-700" data-id="element-581">
                        A deposit will be required to secure your spot, with the
                        balance due 60 days before departure.
                      </p>
                    </li>
                    <li className="flex items-start" data-id="element-582">
                      <CheckCircleIcon size={24} className="text-teal-600 mr-3 mt-1 flex-shrink-0" data-id="element-583" />
                      <p className="text-gray-700" data-id="element-584">
                        All payments are secured through STO Garant, ensuring
                        your booking is protected.
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-585">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-586">
                    Need Help?
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-587">
                    If you have any questions about our trips or the booking
                    process, please don't hesitate to contact us.
                  </p>
                  <div className="space-y-3" data-id="element-588">
                    <div className="flex items-center" data-id="element-589">
                      <PhoneIcon size={20} className="text-teal-600 mr-3 flex-shrink-0" data-id="element-590" />
                      <span className="text-gray-700" data-id="element-591">+31 681180400</span>
                    </div>
                    <div className="flex items-center" data-id="element-592">
                      <MailIcon size={20} className="text-teal-600 mr-3 flex-shrink-0" data-id="element-593" />
                      <span className="text-gray-700" data-id="element-594">
                        Experiencehikes@gmail.com
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Stay Informed Section */}
        <section className="py-16 bg-white w-full" data-id="element-595">
          <div className="container mx-auto px-4" data-id="element-596">
            <div className="text-center mb-12" data-id="element-597">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-598">
                Stay Informed About Upcoming Dates
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-599">
                Join our newsletter to be the first to know about new trips and
                special offers
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto" data-id="element-600">
              {/* Newsletter Column */}
              <div className="bg-gray-50 p-8 rounded-lg shadow-md" data-id="element-601">
                <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-602">
                  <MailIcon size={24} className="inline-block mr-2 text-teal-600" data-id="element-603" />
                  Subscribe to Our Newsletter
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-604">
                  Sign up for our newsletter to receive updates on new hiking
                  destinations, trip dates, special offers, and travel tips
                  directly to your inbox.
                </p>
                <form className="space-y-4" data-id="element-605">
                  <div data-id="element-606">
                    <label htmlFor="newsletter-name" className="block text-gray-700 font-medium mb-2" data-id="element-607">
                      Your Name
                    </label>
                    <input type="text" id="newsletter-name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="Enter your name" required data-id="element-608" />
                  </div>
                  <div data-id="element-609">
                    <label htmlFor="newsletter-email" className="block text-gray-700 font-medium mb-2" data-id="element-610">
                      Your Email
                    </label>
                    <input type="email" id="newsletter-email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" placeholder="Enter your email" required data-id="element-611" />
                  </div>
                  <div className="flex items-start" data-id="element-612">
                    <input type="checkbox" id="newsletter-consent" className="mt-1 mr-2" required data-id="element-613" />
                    <label htmlFor="newsletter-consent" className="text-gray-700 text-sm" data-id="element-614">
                      I agree to receive email updates from Experience Hikes. I
                      understand I can unsubscribe at any time.
                    </label>
                  </div>
                  <button type="submit" className="w-full bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-6 rounded-md transition duration-300" data-id="element-615">
                    Subscribe
                  </button>
                </form>
              </div>
              {/* Upcoming Trips Column */}
              <div className="bg-gray-50 p-8 rounded-lg shadow-md" data-id="element-616">
                <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-617">
                  <CalendarIcon size={24} className="inline-block mr-2 text-teal-600" data-id="element-618" />
                  Upcoming Trip Dates
                </h3>
                <div className="space-y-6" data-id="element-619">
                  <div className="border-b border-gray-200 pb-4" data-id="element-620">
                    <h4 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-621">
                      Zakynthos in Autumn
                    </h4>
                    <p className="text-teal-600 font-medium mb-2" data-id="element-622">
                      03 - 10 September 2025
                    </p>
                    <p className="text-gray-700 mb-3" data-id="element-623">
                      Explore the beautiful island of Zakynthos during the
                      perfect autumn season.
                    </p>
                    <Link to="/greece" className="text-teal-600 hover:text-teal-700 font-medium" data-id="element-624">
                      Learn More
                    </Link>
                  </div>
                  <div className="border-b border-gray-200 pb-4" data-id="element-625">
                    <h4 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-626">
                      Cyprus Autumn Try-out Trip
                    </h4>
                    <p className="text-teal-600 font-medium mb-2" data-id="element-627">
                      15 - 22 October 2025
                    </p>
                    <p className="text-gray-700 mb-3" data-id="element-628">
                      Join our special try-out trip to discover the authentic
                      side of Cyprus.
                    </p>
                    <Link to="/cyprus" className="text-teal-600 hover:text-teal-700 font-medium" data-id="element-629">
                      Learn More
                    </Link>
                  </div>
                  <div data-id="element-630">
                    <h4 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-631">
                      Andalusian Hiking Week
                    </h4>
                    <p className="text-teal-600 font-medium mb-2" data-id="element-632">
                      21 - 28 September 2025
                    </p>
                    <p className="text-gray-700 mb-3" data-id="element-633">
                      Experience the culture and nature of Andalusia with our
                      guided hiking tour.
                    </p>
                    <Link to="/spain" className="text-teal-600 hover:text-teal-700 font-medium" data-id="element-634">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Information Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-635">
          <div className="container mx-auto px-4" data-id="element-636">
            <div className="max-w-4xl mx-auto" data-id="element-637">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-638">
                Important Information About Our Hikes
              </h2>
              <div className="space-y-8" data-id="element-639">
                <div className="bg-white p-6 rounded-lg" data-id="element-640">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-641">
                    Condition
                  </h3>
                  <p className="text-gray-700" data-id="element-642">
                    A good basic walking condition is required for all our
                    trips.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg" data-id="element-643">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-644">
                    Distances
                  </h3>
                  <p className="text-gray-700" data-id="element-645">
                    We walk between 5 and 10 km per day, depending on the
                    terrain and location.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg" data-id="element-646">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-647">
                    Hiking Trails
                  </h3>
                  <p className="text-gray-700" data-id="element-648">
                    Our routes feature a combination of flat and easy terrain
                    and mountainous areas on unpaved roads. Sometimes we walk on
                    asphalt, but also regularly on unpaved roads with loose
                    debris and stones, so it is important to have good grip
                    while walking.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg" data-id="element-649">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-650">
                    Footwear
                  </h3>
                  <p className="text-gray-700" data-id="element-651">
                    Good sturdy (mountain) walking shoes are necessary. Sandals
                    are not recommended for our hikes.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg" data-id="element-652">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-653">
                    Insurance
                  </h3>
                  <p className="text-gray-700" data-id="element-654">
                    Please make sure you have good travel and cancellation
                    insurance, in addition to the legal travel guarantee that we
                    offer ourselves via STO Garant.
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg" data-id="element-655">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-656">
                    General Conditions
                  </h3>
                  <p className="text-gray-700" data-id="element-657">
                    We would like to point out the general terms and conditions
                    that apply when participating in our trips. Please review
                    these carefully before booking.
                  </p>
                  <a href="/terms-conditions" className="text-teal-600 hover:text-teal-700 font-medium mt-2 inline-block" data-id="element-658">
                    View Terms & Conditions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <STOGarantBanner data-id="element-659" />
      </main>
      <Footer data-id="element-660" />
    </div>;
}